import { useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "../../../components/common/Input/Input";
import TelInput from "../../../components/common/telInput/telInput";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import useFileClaimFlow from "../../../hooks/useFileClaimFlow";
import useMotorForm from "../../../hooks/useMotorFormData";
import useValidation from "../../../hooks/useValidation";
import FileClaimMotorLayout from "./fileClaimMotorLayout";

export const ClaimInfoPage = "ClaimInfoPage";

function YourInfoPage() {
  const [formData, setFormData] = useState({});
  const [touched, setTouched] = useState({});
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const { t } = useTranslation();
  const { handleNextSubstep } = useFileClaimFlow();
  const { saveMotorDataInRedux } = useMotorForm(ClaimInfoPage, setFormData);
  const { errors, validateFields } = useValidation();

  const validateForm = (data = formData) => {
    const mergedData = { ...data };
    if (mergedData.countryCode && mergedData.mobile) {
      mergedData.mobileFull = mergedData.countryCode + mergedData.mobile;
    } else {
      mergedData.mobileFull = "";
    }
    const validationConfig = [
      { name: "driverCprNumber", validations: ["required"] },
      { name: "ownerCprNumber", validations: ["required"] },
      { name: "plateNumber", validations: ["required"] },
      { name: "email", validations: ["required", "email"] },
      { name: "mobileFull", validations: ["required", "length"], min: 11 },
    ];
    return validateFields(validationConfig, mergedData);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Uppercase plate number input
    const processedValue = name === "plateNumber" ? value.toUpperCase() : value;
    const updatedForm = { ...formData, [name]: processedValue };
    const updatedTouched = { ...touched, [name]: true };
    setFormData(updatedForm);
    setTouched(updatedTouched);

    // Only validate if the field has been touched or user tried to submit
    if (submitAttempted || updatedTouched[name]) {
      validateForm(updatedForm);
    }
  };

  const continueClickHandler = () => {
    setSubmitAttempted(true);
    if (validateForm()) {
      saveMotorDataInRedux(formData);
      handleNextSubstep();
    }
  };

  return (
    <FileClaimMotorLayout btn_onClick={continueClickHandler}>
      <div className="mx-auto bg-white max767:p-5 w-[500px] max-w-[100%]">
        <div className="max767:hidden">
          <TitleDescription
            title={t("motorInsurance.fileAClaimFlow.yourInfoPage.title")}
            description={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.description"
            )}
          />
        </div>
        <div className="max767:block hidden max767:mb-6">
          <TitleDescription
            title={t("motorInsurance.fileAClaimFlow.yourInfoPage.title")}
            description={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.mobile_description"
            )}
          />
        </div>
        <div>
          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.driver_cpr_number_label"
            )}
            type="number"
            handleChange={handleChange}
            name="driverCprNumber"
            value={formData.driverCprNumber || ""}
            error={
              touched.driverCprNumber || submitAttempted
                ? errors.driverCprNumber
                : null
            }
            data-testid="driverCprNumber"
          />
          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.vehicle_cpr_number_label"
            )}
            type="number"
            handleChange={handleChange}
            name="ownerCprNumber"
            value={formData.ownerCprNumber || ""}
            error={
              touched.ownerCprNumber || submitAttempted
                ? errors.ownerCprNumber
                : null
            }
            data-testid="ownerCprNumber"
          />
          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.plate_number_label"
            )}
            type="text"
            handleChange={handleChange}
            name="plateNumber"
            value={formData.plateNumber || ""}
            error={
              touched.plateNumber || submitAttempted ? errors.plateNumber : null
            }
            data-testid="plateNumber"
          />
          <Input
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.email_address_label"
            )}
            type="text"
            handleChange={handleChange}
            name="email"
            value={formData.email || ""}
            error={touched.email || submitAttempted ? errors.email : null}
            data-testid="email"
          />
          <TelInput
            name="mobile"
            value={formData.mobile || ""}
            error={touched.mobile || submitAttempted ? errors.mobileFull : null}
            onChange={handleChange}
            label={t(
              "motorInsurance.fileAClaimFlow.yourInfoPage.mobile_number_label"
            )}
            className="mobilenumber px-4 py-3 max767:w-[50%] w-[97%] border-r-0 border-0 rounded-[9px] h-[46px] focus:outline-none"
            data-testid="mobile"
          />
        </div>
      </div>
    </FileClaimMotorLayout>
  );
}

export default YourInfoPage;
